import type { RequestInitiator } from '@ms/yammer-telemetry-support';

import type { ApiMiddleware } from '../types';

type RealtimeInitiator = Extract<RequestInitiator, 'realtime' | 'realtime_retry'>;
type RateLimitHandlingHeader = 'oneretry' | 'noretry';

const rateLimitHandlingValues: Record<RealtimeInitiator, RateLimitHandlingHeader> = {
  realtime: 'oneretry',
  realtime_retry: 'noretry',
};

const getRateLimitFields = (initiator: RealtimeInitiator) => ({
  'X-App-Rate-Limit-Handling': rateLimitHandlingValues[initiator],
});

const middleware: ApiMiddleware = async (request) => {
  if (request.initiator !== 'realtime' && request.initiator !== 'realtime_retry') {
    return request;
  }

  const rateLimitFields = getRateLimitFields(request.initiator);

  return {
    ...request,
    headers: {
      ...request.headers,
      ...rateLimitFields,
    },
    query: {
      ...request.query,
      ...rateLimitFields,
    },
  };
};

export default middleware;
